import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9bffff40")

_pushScopeId("data-v-9bffff40")
const _hoisted_1 = { class: "menu-button" }
const _hoisted_2 = { class: "content-wrap" }
const _hoisted_3 = { class: "item-wrap item-first" }
const _hoisted_4 = { class: "item-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_PopUpWithButton = _resolveComponent("PopUpWithButton")
  const _component_GeneralSettingsMenu = _resolveComponent("GeneralSettingsMenu")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PopUpWithButton, {
      name: "ic25-more",
      size: "25px"
    }, {
      content: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              class: "item",
              mode: "flat",
              size: "l",
              icon: { spriteUrl: '/image/videoconf-icons.svg', name: 'ic25-gear', color: '--sui-gray-700', width: '25px', height: '25px'},
              onClick: _ctx.showModal,
              ref: "isGeneralSettings"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.t('menuList.generalSettings')), 1)
              ]),
              _: 1
            }, 8, ["icon", "onClick"])
          ]),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listMenuDefault, (item) => {
              return (_openBlock(), _createBlock(_component_Button, {
                class: "item",
                mode: "flat",
                size: "l",
                onClick: item.click,
                icon: { spriteUrl: '/image/videoconf-icons.svg', name: item.icon, color: '--sui-gray-700', width: '25px', height: '25px'}
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "icon"]))
            }), 256))
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, null, {
      default: _withId((initTab) => [
        _createVNode(_component_GeneralSettingsMenu, { currentTabProp: initTab }, null, 8, ["currentTabProp"])
      ]),
      _: 1
    })
  ]))
})